// src/components/Amenities.js
import "./Amenities.css";

function Amenities() {
  return (
    <div className="amenities-container">
      <h2>Amenities</h2>
      <p>
        At Welcome Inn, we offer the following amenities to ensure your stay is
        convenient and enjoyable:
      </p>
      <ul className="amenities-list">
        <li className="amenity-item">Free Wi-Fi</li>
        <li className="amenity-item">Complimentary Parking</li>
        <li className="amenity-item">24-Hour Front Desk</li>
        <li className="amenity-item">Daily Housekeeping</li>
        <li className="amenity-item">
          In-Room Coffee, Microwave &amp; Mini Fridge
        </li>
        <li className="amenity-item">Accessible Rooms Available</li>
      </ul>
    </div>
  );
}

export default Amenities;
